import { assertValidVersion } from "@tsparticles/engine";
import { LineDrawer } from "./LineDrawer.js";
export async function loadLineShape(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addShape(new LineDrawer(), refresh);
}
